// Import Ionic Components
import { IonList, IonListHeader, IonLoading, IonItem, IonLabel, useIonViewWillLeave } from "@ionic/react";

// Import React Libraries
import React, { useContext, useState, useCallback } from "react";
import { RouteComponentProps } from "react-router-dom";
import { useHistory } from "react-router";

// Import Css File
import styles from "./subCategories.module.scss";
import classNames from "classnames/bind";

// Import custom providers and components
import {
  useGetAllCategoriesQuery,
  useGetCategoryByIdQuery,
  useGetSubCategoriesQuery,
} from "../../providers/categories";
import { Product } from "@core/types";
import { ProductsSearchPageLayoutOld } from "../../components/ProductsSearchPageLayoutOld";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const SubCategories: React.FC<RouteComponentProps> = (props: any) => {
  let history = useHistory(); // For Push page
  const { id } = props.match.params;
  const { data: { allCategories } = {}, isLoading } = useGetAllCategoriesQuery();

  const { data: subCategories } = useGetSubCategoriesQuery(id, { enabled: !!allCategories });
  const { data: parentCategory } = useGetCategoryByIdQuery(id, { enabled: !!allCategories });

  const { t } = useTranslation();
  const [searchResult, setSearchResult] = useState<Product[]>([]);

  const isHaveSubCategories = useCallback(
    (id: string) => {
      return !!allCategories?.some((item) => String(item.parent) === id);
    },
    [allCategories],
  );

  const openShop = useCallback(
    (id: string, name: string) => {
      if (isHaveSubCategories(id)) {
        history.push("/categories/" + id + "/subcategories");
      } else {
        history.push("/products/" + id + "/" + name + "/popular");
      }
    },
    [history, isHaveSubCategories],
  );

  useIonViewWillLeave(() => {
    setSearchResult([]);
  }, [props.match.params]);

  return (
    <>
      <IonLoading isOpen={isLoading} message={t("Please wait...")} />
      {!isLoading && (
        <ProductsSearchPageLayoutOld
          pageTitle={parentCategory?.name || ""}
          breadcrumbsTitle={parentCategory?.name || ""}
        >
          <IonList mode="ios" className={searchResult.length ? cx("hide") : cx("categoriesList", "ion-no-padding")}>
            <IonListHeader className={"ion-hide-md-up"}>{parentCategory?.name}</IonListHeader>
            {subCategories?.map((subCategory) => (
              <IonItem
                key={subCategory.id}
                onClick={() => openShop(String(subCategory.id), subCategory.name)}
                button
                type="button"
                className={cx("ion-no-padding")}
              >
                <IonLabel>{subCategory.name}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        </ProductsSearchPageLayoutOld>
      )}
    </>
  );
};

export default SubCategories;
